<div class="kt-container  kt-grid__item kt-grid__item--fluid">

    <!--Begin::App-->
    <div class="kt-grid kt-grid--desktop kt-grid--ver kt-grid--ver-desktop kt-app">

        <!--Begin:: App Aside Mobile Toggle-->
        <button class="kt-app__aside-close" id="kt_user_profile_aside_close">
            <i class="la la-close"></i>
        </button>

        <!--End:: App Aside Mobile Toggle-->

        <!--Begin:: App Aside-->
        <div class="kt-grid__item kt-app__toggle kt-app__aside" id="kt_user_profile_aside">

            <!--begin:: Widgets/Applications/User/Profile4-->
            <div class="kt-portlet kt-portlet--height-fluid-">
                <div class="kt-portlet__body">

                    <!--begin::Widget -->
                    <div class="kt-widget kt-widget--user-profile-4">
                        <div class="kt-widget__head">
                            <div class="kt-widget__media">
                                <img class="kt-widget__img kt-hidden-" *ngIf="isImage"
                                    src="{{assetsPath + userBasicInfo.image}}" alt="image">
                                <img class="kt-widget__img kt-hidden-" *ngIf="!isImage"
                                    src="/assets/media/users/default.jpg" alt="image">
                                <div
                                    class="kt-widget__pic kt-widget__pic--danger kt-font-danger kt-font-boldest kt-font-light kt-hidden">
                                    AD
                                </div>
                            </div>
                            <div class="kt-widget__content">
                                <div class="kt-widget__section">
                                    <a href="#" class="kt-widget__username">
                                        {{ userBasicInfo.displayName}}
                                    </a>
                                    <div class="kt-widget__button">
                                        <span class="btn btn-label-warning btn-sm">Aktif Gönüllü</span> <br
                                            *ngIf="userBasicInfo.isAlumni"><br *ngIf="userBasicInfo.isAlumni">
                                        <span class="btn btn-label-brand btn-sm"
                                            *ngIf="userBasicInfo.isAlumni">Mezun</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="kt-widget__body">
                            <a [routerLink]="['/my-profile']" class="kt-widget__item">
                                Genel Bilgiler
                            </a>
                            <a [routerLink]="['/update-my-basic-information']" class="kt-widget__item">
                                Temel Bilgilerimi Güncelle
                            </a>
                            <a [routerLink]="['/update-my-role-settings']" class="kt-widget__item">
                                Gönüllülük Alanlarım
                            </a>
                            <a [routerLink]="['/update-my-password']" class="kt-widget__item">
                                Şifremi Değiştir
                            </a>
                            <a [routerLink]="['/my-profession-list']" class="kt-widget__item">
                                Kariyer Bilgilerim
                            </a>
                            <a [routerLink]="['/my-education-list']" class="kt-widget__item">
                                Eğitim Bilgilerim
                            </a>
                            <a [routerLink]="['/judge-form']" class="kt-widget__item">
                                Jürilik Bilgi Formu
                            </a>
                            <a [routerLink]="['/referee-form']" class="kt-widget__item kt-widget__item--active">
                                Hakemlik Bilgi Formu
                            </a>
                        </div>
                    </div>

                    <!--end::Widget -->
                </div>
            </div>

            <!--end:: Widgets/Applications/User/Profile4-->

            <!--Begin:: Portlet-->
            <div class="kt-portlet">
                <div class="kt-portlet__body">
                    <div class="kt-widget1 kt-widget1--fit">
                        <div class="kt-widget1__item">
                            <div class="kt-widget1__info">
                                <h3 class="kt-widget1__title">Başvurularım</h3>
                                <span class="kt-widget1__desc">Aktif başvuru sayısı</span>
                            </div>
                            <span class="kt-widget1__number kt-font-brand">0</span>
                        </div>
                        <div class="kt-widget1__item">
                            <div class="kt-widget1__info">
                                <h3 class="kt-widget1__title">Rozetlerim</h3>
                                <span class="kt-widget1__desc">Rozet sayısı</span>
                            </div>
                            <span class="kt-widget1__number kt-font-success">0</span>
                        </div>
                    </div>
                </div>
            </div>

            <!--end:: Portlet-->
        </div>

        <!--End:: App Aside-->

        <!--Begin:: App Content-->
        <div class="kt-grid__item kt-grid__item--fluid kt-app__content">
            <div class="row">
                <div class="col-xl-12">
                    <div class="kt-portlet">
                        <div class="kt-portlet__head">
                            <div class="kt-portlet__head-label">
                                <h3 class="kt-portlet__head-title">Hakemlik Bilgi Formu</h3>
                            </div>
                        </div>
                        <div class="kt-portlet__body" *ngIf="isFilled">
                            <div class="kt-section kt-section--first">
                                <div class="kt-section__body">

                                    <div class="form-group">
                                        <p>Formu doldurduğunuz için teşekkür ederiz.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <form [formGroup]="createRefereeForm" (ngSubmit)="save()" class="kt_login_form" *ngIf="!isFilled">
                            <div class="kt-portlet__body">
                                <div class="kt-section kt-section--first">
                                    <div class="kt-section__body">

                                        <div class="form-group">
                                            <h5>Lütfen formu doldurmadan önce eğitim ve kariyer bilgilerinizi tamamen
                                                giriniz. Eğitim ve kariyer bilgileriniz de formun bir parçası olacaktır.
                                                Profil ekranındaki menüleri kullanarak <a
                                                    [routerLink]="['/my-education-list']">eğitim</a> ve <a
                                                    [routerLink]="['/my-profession-list']">kariyer</a> bilgilerinizi
                                                girebilirsiniz.</h5>
                                            <hr>
                                            <p><b>Rol Tanımı:</b> <br><br> 

                                                Bilim Kahramanları Buluşuyor turnuvalarında hakem gönüllüsü olarak görev alacak ve robot maçlarını dikkatli ve adil bir şekilde yöneterek, takımların keyifli bir turnuva geçirmesini sağlayacaktır. <br><br>
                                                Hakem gönüllülerinin en az 2 eğitime katılması ve en az iki turnuvada destek olması beklenmektedir. Her turnuva 1 gün sürmektedir ve haftasonu gerçekleştirilir. <br><br>
                                                <b>Aranan Özellikler:</b><br><br>
                                                
                                                - Çocuklarla doğru iletişim becerilerine sahip olmak. <br>
                                                - Sorumluluk almak ve alınan sorumluluğu yerine getirmek. <br>
                                                - Çocuklara davranışları ve karakteriyle rol model olmak. <br>
                                                - Konsantrasyonu yüksek, pozitif ve güler yüzlü olmak. <br>
                                                - Okuduğunu anlamak, anladığını doğru şekilde uygulamak. <br>
                                                - Muhakeme yeteneğine sahip olmak.  <br>
                                                - Tanımlı kurallara uygun şekilde hızlı ve doğru karar verebilmek. <br>
                                                - Ayrım gözetmeksizin her takıma ve kişiye adil şekilde yaklaşmak. <br>
                                            
                                            </p>
                                            <label>Turnuvaya katılan takımlarla herhangi bir bağınız var mı? (Sadece 2022-2023 SuperPowered sezonu için cevaplayınız.)</label>
                                            <div class="kt-radio-list">
                                                <label class="kt-radio kt-radio--brand">
                                                    <input type="radio" name="isConflict" value="yes"
                                                        formControlName="isConflict">
                                                    Evet
                                                    <span></span>
                                                </label>
                                                <label class="kt-radio kt-radio--brand">
                                                    <input type="radio" name="isConflict" value="no"
                                                        formControlName="isConflict">
                                                    Hayır
                                                    <span></span>
                                                </label>
                                            </div>
                                            <small class="form-text text-warning"
                                                *ngIf="f.isConflict.errors?.required">Lütfen bir seçenek
                                                işaretleyiniz!</small>
                                        </div>

                                        <div class="form-group">
                                            <label>Daha önce Bilim Kahramanları Buluşuyor turnuvalarına katıldınız mı?</label>
                                            <div class="kt-radio-list">
                                                <label class="kt-radio kt-radio--brand">
                                                    <input type="radio" name="isVolunteeredBefore" value="yes"
                                                        formControlName="isVolunteeredBefore"> Evet
                                                    <span></span>
                                                </label>
                                                <label class="kt-radio kt-radio--brand">
                                                    <input type="radio" name="isVolunteeredBefore" value="no"
                                                        formControlName="isVolunteeredBefore"> Hayır
                                                    <span></span>
                                                </label>
                                            </div>
                                            <small class="form-text text-warning"
                                                *ngIf="f.isVolunteeredBefore.errors?.required">Lütfen bir seçenek
                                                işaretleyiniz!</small>
                                        </div>
                                        <div class="form-group">
                                            <label class="col-form-label">Cevabınız "Evet" ise rolünüz neydi?</label>

                                            <div class="kt-checkbox-list">
                                                <label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
                                                    <input (change)="onRoleChange('Hakem gönüllüsü', $event.target.checked)" name="first" type="checkbox">
                                                    Hakem gönüllüsü
                                                    <span></span>
                                                </label>
                                                <label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
                                                    <input (change)="onRoleChange('Jüri gönüllüsü', $event.target.checked)" name="second" type="checkbox">
                                                    Jüri gönüllüsü
                                                    <span></span>
                                                </label>
                                                <label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
                                                    <input (change)="onRoleChange('Alan gönüllüsü', $event.target.checked)" name="third" type="checkbox">
                                                    Alan gönüllüsü
                                                    <span></span>
                                                </label>
                                                <label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
                                                    <input (change)="onRoleChange('Takım üyesi', $event.target.checked)" name="fourth" type="checkbox">
                                                    Takım üyesi
                                                    <span></span>
                                                </label>
                                                <label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
                                                    <input (change)="onRoleChange('Takım koçu', $event.target.checked)" name="fifth" type="checkbox">
                                                    Takım koçu
                                                    <span></span>
                                                </label>
                                                <label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
                                                    <input (change)="onRoleChange('Takım danışmanı', $event.target.checked)" name="sixth" type="checkbox">
                                                    Takım danışmanı
                                                    <span></span>
                                                </label>
                                                <label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
                                                    <input (change)="onRoleChange('Diğer', $event.target.checked)" name="seventh" type="checkbox">
                                                    Diğer
                                                    <span></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label>Bilim Kahramanları Derneği'nin diğer programlarında bulundunuz mu?</label>
                                            <div class="kt-radio-list">
                                                <label class="kt-radio kt-radio--brand">
                                                    <input type="radio" name="isOtherProgram" value="yes"
                                                        formControlName="isOtherProgram"> Evet
                                                    <span></span>
                                                </label>
                                                <label class="kt-radio kt-radio--brand">
                                                    <input type="radio" name="isOtherProgram" value="no"
                                                        formControlName="isOtherProgram"> Hayır
                                                    <span></span>
                                                </label>
                                            </div>
                                            <small class="form-text text-warning"
                                                *ngIf="f.isOtherProgram.errors?.required">Lütfen bir seçenek
                                                işaretleyiniz!</small>
                                        </div>
                                        <div class="form-group">
                                            <label class="col-form-label">Cevabınız "Evet" ise hangi programa katıldınız ve rolünüz neydi? (Örnek: Merak Makinesi - Gönüllü)</label>

                                            <textarea formControlName="programExperience" rows="3" class="form-control"
                                                placeholder="Açıklayınız.."></textarea>
                                            <small class="form-text text-warning"
                                                *ngIf="f.programExperience.errors?.maxlength">Lütfen 250 karakteri
                                                geçmeyiniz!</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="kt-portlet__foot">
                                <div class="kt-form__actions">
                                    <div class="row">
                                        <div class="col-lg-9 col-xl-9">
                                            <button type="submit" class="btn btn-success btn-bold">Kaydet</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!--End:: App Content-->
    </div>

    <!--End::App-->
</div>